var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      attrs: {
        id: "app",
        "data-theme": _vm.getWCAGSettings.contrastMode ? "contrast" : "default",
        "cursor-mode": _vm.getWCAGSettings.optionallyBiggerCursor
          ? "bigger"
          : "default"
      }
    },
    [
      _c(
        "transition",
        {
          attrs: {
            name: "slide",
            "enter-active-class": "animated slideInDown faster",
            "leave-active-class": "animated slideOutUp faster"
          }
        },
        [
          _vm.notification
            ? _c(
                "dropdown-notification",
                _vm._b({}, "dropdown-notification", _vm.notification, false)
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoggedInLayoutVisible ? _c("logged-in-layout") : _c("router-view"),
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            mode: "in-out",
            "enter-active-class": "animated fadeIn faster",
            "leave-active-class": "animated fadeOut faster"
          }
        },
        [
          _vm.modalComponent
            ? _c("modal", {
                key: _vm.modalKey,
                attrs: { component: _vm.modalComponent }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSmartAppBanner ? _c("android-smart-app-banner") : _vm._e(),
      _vm._v(" "),
      _vm.showSmartAppBanner ? _c("ios-smart-app-banner") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=7ba5bd90&
// module id = null
// module chunks = 